export function createMarkup(input) {
	return {__html: input}
 }